import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(() => ({
  asterisk: {
    color: 'red',
  },
}));

export default styles;
